import styled, { css } from 'styled-components'

import { Rect } from 'modules/shares/types'

export const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

interface LayerParsedProps {
  isLayerUnclickable: boolean
  frame: Rect
}

export const LayerParsed = styled.div<LayerParsedProps>(
  ({ frame, isLayerUnclickable }) => css`
    position: absolute;
    top: ${frame.y}px;
    left: ${frame.x}px;
    width: ${frame.width}px;
    height: ${frame.height}px;

    pointer-events: ${isLayerUnclickable ? 'none' : 'auto'};
  `
)
